import React from 'react'

import { Text } from '@wartek-id/text'

/**
 * ListHeading to be used for titles inside pages
 *
 * e.g.
 * Seri Pelatihan
 * Pelatihan dengan berbagai tema berbeda yang berisi kumpulan topik berkaitan dan runut untuk dipelajari
 */

interface Props {
  /** ListHeading title */
  title: String
  /** ListHeading detail, omitempty */
  detail?: String
}

const ListHeading = ({ title, detail }: Props) => (
  <section className="mt-6 mb-3">
    <Text variant="heading-lg">{title}</Text>
    {!!detail && (
      <Text variant="body-sm" color="subdued">
        {detail}
      </Text>
    )}
  </section>
)

export default ListHeading
